const { get, post, put, del } = require("network/http/api")

export const getAIAgentScenario = (platform) => {
  return get('/scenario/platform/' + platform)
}
